import { screenSizeSwitch } from '../../../../lib/helpers';
import ProductViewPage1Big from './ProductViewPage1Big';
import ProductViewPage1Small from './ProductViewPage1Small';

export default screenSizeSwitch([[991, ProductViewPage1Small], ProductViewPage1Big]);
